import { useState } from 'react';
import { Notification, FreshChat, Form, Contacts } from 'components';
import { GlobalStyle, AppContainer, Content, Image } from 'Styles';
import { getSearchParams } from 'utils';
import products from 'config/products';
import './App.css';

const App = () => {
  const [widget, setWidget] = useState();
  const searchParams = getSearchParams();

  const productName = process.env.REACT_APP_PRODUCT_NAME;
  const productConfig = products[productName];

  const { background, logo, width, freshchat, whatsapp, iMessage } = productConfig;
  const isContact = freshchat || whatsapp || iMessage;

  return (
    <>
      <GlobalStyle $background={background} />
      <Notification />
      <FreshChat token={freshchat} setWidget={setWidget} searchParams={searchParams} />
      <AppContainer>
        <Image src={logo} width={width} $isContact={isContact} />
        <Content>
          {isContact && (
            <Contacts productConfig={productConfig} widget={widget} searchParams={searchParams} />
          )}
          <Form searchParams={searchParams} />
        </Content>
      </AppContainer>
    </>
  );
};

export default App;
